import { Component, OnInit, Input, inject } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { InteractorResponse } from 'src/app/core/models/interactor-response';
import { AbstractEntityService } from 'src/app/core/services/abstract/abstract-entity-service';
import { T22EntityDTO, T22EntityItemDTO } from 'src/app/store/order/model';

@Component({
  selector: 'app-attr-entity',
  templateUrl: './attr-entity.component.html',
  styleUrls: ['./attr-entity.component.scss'],
  standalone: false,
})
export class AttrEntityComponent implements OnInit {
  private entityService = inject(AbstractEntityService);

  @Input() propertyId: string;
  @Input() entity: T22EntityDTO;
  @Input() caption: string;
  @Input() value: string;
  @Input() entityValue: T22EntityItemDTO;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  dataSource: any;

  ngOnInit(): void {
    this.dataSource = new Array<T22EntityItemDTO>();

    if (this.entityValue && +this.entityValue > 0) {
      this.dataSource.push(this.entityValue);
    }

    if (this.isLoadFull()) {
      this.entityService.getAllValues(this.entity.id).subscribe(response => {
        if (response.isSucceeded) {
          response.result.forEach(x => {
            this.dataSource.push(x);
          });
        } else {
          this.showErrorMessage(response);
        }
      });
    }
  }

  onOpened() {
    if (this.isLoadFull()) {
      return;
    }

    this.dataSource = new DataSource({
      key: 'ID',
      load: async loadOptions => {
        return await this.entityService
          .getValuesByMask(this.entity.id, loadOptions.searchValue)
          .toPromise()
          .then(response => {
            let result = [];
            if (
              this.entityValue &&
              response.result &&
              !response.result.find(x => {
                return x.id == this.entityValue.id;
              })
            ) {
              result.push(this.entityValue);
            }

            if (response.isSucceeded) {
              response.result.forEach(x => {
                result.push(x);
              });
            } else {
              this.showErrorMessage(response);
            }

            return {
              data: result,
            };
          });
      },
    });
  }

  isLoadFull() {
    return this.entity.rowsCountLimit === 0;
  }

  showErrorMessage(response: InteractorResponse<T22EntityItemDTO[]>) {
    notify({ message: response.message + ' ' + response.errors, width: 600 }, 'error', 5000);
  }
}
